import { useSelector } from 'react-redux';
import { getSelectedConversations } from '../../thread-list-member-sidebar/selectors/threadListMembersBatchUpdatesSelectors';
import AsyncBatchThreadOperationsToolbarContainer from '../../code-splitting/components/AsyncBatchThreadOperationsToolbarContainer';
import AsyncBatchSearchOperationsToolbarContainer from '../../code-splitting/components/AsyncBatchSearchOperationsToolbarContainer';
import { isInSearchAndFilterMode as getIsInSearchAndFilterMode } from 'conversations-inbox-lib/thread-search-and-filtering/public/selectors';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import { jsx as _jsx } from "react/jsx-runtime";
const BatchThreadOperationsToolbarWrapper = () => {
  const threadIds = useSelector(getSelectedConversations);
  const isInSearchAndFilterMode = useSelector(getIsInSearchAndFilterMode);
  const currentView = useCurrentView();
  if (threadIds && threadIds.size) {
    if (isInSearchAndFilterMode) {
      return /*#__PURE__*/_jsx(AsyncBatchSearchOperationsToolbarContainer, {
        threadIds: threadIds
      });
    }
    return /*#__PURE__*/_jsx(AsyncBatchThreadOperationsToolbarContainer, {
      threadIds: threadIds,
      view: currentView
    });
  }
  return null;
};
BatchThreadOperationsToolbarWrapper.displayName = 'BatchThreadWrapper';
export default BatchThreadOperationsToolbarWrapper;